<script setup lang="ts">
import type { Ref } from 'vue'
import { reactive, ref } from 'vue'
import type { FieldInterface } from '@voix/types'
import PageFieldsIndex from './PageFieldsIndex.vue'

import PageFieldsNew from './PageFieldsNew.vue'
import PageFieldsEdit from './PageFieldsEdit.vue'

const emit = defineEmits(['close'])

const newPageField = ref(false)
const pageField: Ref<FieldInterface | null> = ref(null)

function setPageField(editingPageField: FieldInterface) {
  pageField.value = editingPageField
}

function deselectPageField() {
  pageField.value = null
}

function cancelNewPageField() {
  newPageField.value = false
}
</script>

<template>
  <div>
    <PageFieldsNew v-if="newPageField" @back="cancelNewPageField" />
    <PageFieldsEdit v-else-if="pageField" :page-field="pageField" @back="deselectPageField" />
    <PageFieldsIndex v-else @new="newPageField = true" @close="emit('close')" @select="setPageField" />
  </div>
</template>
